<template>
  <scout-topic-panel
    title="スカウト済み"
    name="scout"
    tooltip="掲載期間＋１週間、無料で再スカウトを送信することができます。"
  >
    <router-link
      v-if="!isFutureContract(contractId)"
      :to="{ name: 'scoutScouted', params: { contractId: contractId + '' , jobId: jobId + ''} }"
      class="pega-text-link"
    >
      <span
        data-test="link-text"
        class="boss-scoutandlike-text"
      >{{ count }}名<br>
        <small
          v-if="scoutEndDate"
          data-test="scout-end-date"
        ><span class="wrap-block">再送期限：</span><span class="wrap-block">{{ scoutEndDate | formatDate }}まで</span></small>
      </span>
    </router-link>
  </scout-topic-panel>
</template>

<script>
import ScoutTopicPanel from '@/components/atoms/ScoutTopicPanel'
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'

export default {
  components: { ScoutTopicPanel },
  filters: {
    formatDate (val) {
      return dayjs(val).format('YYYY/MM/DD')
    }
  },
  props: {
    contractId: {
      type: Number,
      required: true
    },
    jobId: {
      type: Number,
      required: true
    },
    scoutEndDate: {
      type: String,
      default: null
    },
    count: {
      validator: prop => typeof prop === 'number' || prop === '...',
      default: '...'
    }
  },
  computed: {
    ...mapGetters('contracts', [
      'isFutureContract'
    ])
  }
}

</script>
